@if (isLoading()) {
  <ngx-skeleton-loader
    class="custom-skeleton"
    [count]="1"
    animation="pulse"
    appearance="line"
    [theme]="{height: '60px', 'margin-bottom': '2rem', background: 'var(--skeleton-color)'}"
  />
  <div class="row">
    <div class="col-lg-3">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '200px', 'margin-bottom': '2rem', background: 'var(--skeleton-color)'}"
      />
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="2"
        animation="pulse"
        appearance="line"
        [theme]="{height: '400px', 'margin-bottom': '2rem', background: 'var(--skeleton-color)'}"
      />
    </div>
    <div class="col-lg-9">
      <ngx-skeleton-loader
        class="custom-skeleton"
        [count]="1"
        animation="pulse"
        appearance="line"
        [theme]="{height: '259px', 'margin-bottom': '2rem', background: 'var(--skeleton-color)'}"
      />
    </div>
  </div>
} @else {
  <div class="d-md-flex justify-content-between align-items-center mb-4">
    <a class="fs-4"  [routerLink]="[Resources.PropertiesProfile | resourceById: data().buildingId]" ngbTooltip="{{ 'MENU.APARTMENTS' | translate }}">
      <i class="las la-arrow-left"></i>
      {{ 'APARTMENT.APARTMENT_NO' | translate:{ number: apartmentInformation.number } }}
    </a>

    <div class="d-flex mt-2 mt-md-0 justify-content-between align-items-center">
      <label class="mb-0 me-2"> {{ 'APARTMENT.PERIOD' | translate }}</label>
      <p-calendar
        dateFormat="yy, MM"
        view="month"
        appendTo="body"
        [formControl]="periodFormControl"/>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <apartment-card [apartment]="data()" (edit)="loadData()"/>

      <div class="d-flex justify-content-start">
        <ul class="nav nav-tabs-custom mb-3">
          @for (tab of tabs;track $index) {
            <li class="nav-item">
              <a
                class="nav-link cursor-pointer"
                [class.active]="activeTab === tab.id"
                (click)="selectTab(tab)"
              >
                <i [ngClass]="tab.iconClass" class="me-1"></i>
                <span class="fs-17">{{ tab.titleKey | translate }}</span>
              </a>
            </li>
          }
        </ul>
      </div>

      @switch (activeTab) {
        @case (Tabs.Contracts) {
          <contracts [apartment]="data()" (successEvent)="loadData()"></contracts>
        }
        @case (Tabs.Meters) {
          <app-meters [apartment]="data()" [property]="data().building" (successEvent)="loadData()"/>
        }
        @case (Tabs.Readings) {
          <apartment-readings
            [apartmentId]="data().id"
            [period]="periodFormControl.value"
          />
        }
        @case (Tabs.Payments) {
          <app-balances [apartment]="data()"></app-balances>
        }
        @case (Tabs.Invoices) {
          <apartment-invoices
            [apartmentId]="apartmentInformation.apartmentId"
            [period]="periodFormControl.value"
            [renter]="data()?.rentalContract?.renter"
          />
        } @case (Tabs.Documents) {
          <app-documents
            [apartmentId]="apartmentInformation.apartmentId"
            [hideActions]="true"
          />
        }
      }
    </div>

<!--    <div class="col-lg-3">-->
<!--      <renter-informat  ion [renterInformation]="renterInformation" [apartment]="data()" (reload)="loadData()"/>-->
<!--    </div>-->
  </div>
}
